export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><g class=\"nc-icon-wrapper\"><polygon points=\"3,5 8,11 13,5 \"/></g></svg>";